<template>
  <div class="selecet_products">
    <Flow v-bind:step="2"/>
    <ProductsList ref="productsList" :sendDeleteId="deleteId" v-on:addItemChild="addItem" v-on:checkCartFromApi="checkCartFromApi" />

    <button class="cart_btn" :class="{'scrollBottom': cartPosition}" v-on:click="cart()">
      <span class="">
        <span class="cart_image"><img src="../../assets/images/cart.png" alt=""></span>
        <span class="item_count rb">{{ purchaseCartCount }}</span>
      </span>
    </button>

    <cart
      ref="cart"
      @changeBC="recieveChangeBC"
      :open="this.cartOpen"
      :nowBC="nowBC"
      :addItem="this.cartAdd"
      :cartChange="this.cartChange"
      v-model="addItem"
      @cartCount="cartCount"
      @close="close()"
      @deleteProductId="recieveDeleteProductId"
      @checkCart="checkCart()"
    />

    <div class="service_wrap bg_white mt12 pt16 pb48">
      <!-- 亜w理引きページテスト用 -->
      <!-- <div class="pb24 ml16">
        <input v-bind:checked="isDiscount"class="payment_radio" type="radio" name="address">
        <label class="payment_contents rb" v-on:click="isDiscountButton()">
          割引ページを表示する
        </label>
      </div> -->
      <!-- ここまで -->

      <router-link class="btn_yellow" :to="{ name: 'selectBC' }">次のBCで買い物する</router-link>
      <a href="#" class="btn_blue" @click.stop.prevent="checkCart()">次へ</a>
      <router-link class="btn_delete btn_back" :to="{ name: 'selectBC' }">戻る</router-link>
    </div>
  </div>

</template>

<script>
import Flow from '@/components/purchase/Flow'
import ProductsList from '@/components/purchase/ProductsList'
import Cart from '@/components/purchase/Cart'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';

export default {
  components: {
    Flow,
    ProductsList,
    Cart
  },
  data () {
    return {
      cartPosition: false,
      nowBC: this.purchaseNowBC,
      cartOpen: false,
      isSelect: {
        bool: false
      },
      itemDetail: {
        open: false
      },
      cartAdd: [],
      // itemCount: 0,
      isPermit: false,
      cartChange: false,
      deleteId: '',

      isDiscount: true, // 割引ページを表示するためのテスト用
    };
  },
  methods: {
    // 割引画面テスト用
    isDiscountButton() {
      this.isDiscount ? this.isDiscount = false : this.isDiscount = true;
    },
    // 割引画面テスト用ここまで
    recieveChangeBC(bc) {
      localStorage.setItem('nowBC', this.purchaseNowBC);
      this.nowBC = bc;
      // console.log('recieveChangeBC bc:'+bc + 'this.nowBC'+this.nowBC);
    },
    cart () {
      scrollPosition.open();
      this.cartOpen = true;
      this.nowBC = this.purchaseNowBC;
      // localStorage.getItem('nowBC');
    },
    close () {
      this.cartOpen = false;
    },
    addItem (item) {
      this.cartAdd = item;
      this.itemCount += 1;
      this.isPermit = true;
    },
    cartCount (count) {
      this.itemCount = count;
    },
    checkCart() {
      // if(this.isDiscount) {
      //   this.$router.push({ name: 'PurchaseDiscount' });
      //   return;
      // }
      let bcList = JSON.parse(localStorage.getItem('selectBC'));
      if(bcList) {
        for (var i = 0; i < bcList.length; i++) {
          let bcItem = JSON.parse(localStorage.getItem(bcList[i]));
          if(bcItem) {
            if(bcItem.length != 0) {
              this.$router.push({ name: 'PurchaseDiscount' });
              // this.$router.push({ name: 'purchaseSelectPaymentAndShipping' });
              return false;
            }
            // this.isPermit = true;
            // return true;
          }
        }
      }
    },
    permitCheck() {
      this.isPermit = false;
      // どのBCのカートにも商品がなければページ遷移させない
      let bcList = JSON.parse(localStorage.getItem('selectBC'));
      if(bcList) {
        for (var i = 0; i < bcList.length; i++) {
          let bcItem = localStorage.getItem(bcList[i]);
          if(bcItem) {
            this.isPermit = true;
            return true;
          }
        }
      }
    },
    checkCartFromApi(data) {
      this.cartChange = data; // true
    },
    recieveDeleteProductId(deleteProductId) {
      this.deleteId = deleteProductId;
    },
    handleScroll() {
      const SelectProducts = document.querySelector('.selecet_products');
      if(!SelectProducts) return;
      const htmlHeight = document.getElementsByClassName("selecet_products")[0].clientHeight;
      const windowHeight = window.innerHeight;
      const scrollHeight = window.scrollY
      if (htmlHeight - (windowHeight + scrollHeight) == 0) {
        this.cartPosition = true;
      } else {
        this.cartPosition = false;
      }
    },
    setCartCount() {
      this.$store.commit('resetCartCount', 0);
      let bcList = JSON.parse(localStorage.getItem('selectBC'));
      if(bcList) {
        for (var i = 0; i < bcList.length; i++) {
          let bcItems = JSON.parse(localStorage.getItem(bcList[i]));
          if(bcItems) {
            this.$store.commit('addCartCount', bcItems.length);
          }
        }
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  computed: mapGetters(['purchaseCartCount', 'purchaseNowBC']),
  created() {
    // console.log('created selectProducts');
    // this.$route.query.bc ? this.nowBC = this.$route.query.bc : this.nowBC = localStorage.getItem('nowBC');
    this.nowBC = this.purchaseNowBC;
    this.setCartCount();
    // this.permitCheck();
  },

  watch: {
    nowBC () {
      this.$refs.productsList.getProducts(this.purchaseNowBC);
      this.$refs.cart.init(this.purchaseNowBC);
    },
  }
}
</script>

<style lang="css" scoped>
.btn_blue {
  margin-top: 26px;
}

/* カート */
.cart_btn {
  background-color: rgba(52, 154, 247, 0.8);
  border-radius: 100px;
  border: none;
  bottom: 100px;
  height: 64px;
  position: fixed;
  right: 28px;
  width: 64px;
  z-index: 0;
}

.cart_btn.scrollBottom {
  bottom: 10%;
}

.cart_btn .cart_image {
  display: block;
  margin: auto;
  width: 38px;
}

.cart_btn .item_count {
  align-items: center;
  background: #349AF7;
  border: 2px solid #FFFFFF;
  border-radius: 100px;
  color: #fff;
  display: flex;
  font-size: 14px;
  height: 25px;
  justify-content: center;
  position: absolute;
  right: -12px;
  top: -4px;
  width: 25px;
}

.btn_back {
  margin-top: 26px;
}

</style>



// WEBPACK FOOTER //
// src/views/purchase/SelectProducts.vue